import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { GenericSwitchList } from '@lumapps/designer-widget-settings/components/GenericSwitchList';
import type { Setting } from '@lumapps/designer-widget-settings/types';
import { Heading } from '@lumapps/lumx/react';
import { PlaylistFieldOrder } from '@lumapps/play-playlists/types';
import { GLOBAL, useTranslate } from '@lumapps/translations';
import { WIDGET_BASE } from '@lumapps/widget-base/keys';

import { WIDGET_PLAYLIST } from '../../../keys';
import { WidgetPlaylistProperties } from '../../../types';

import './index.scss';

export type PlaylistMetadata = Pick<WidgetPlaylistProperties, 'playlistFieldOrder'>;

export interface PlaylistMetadataSelectionProps {
    className?: string;
    properties: PlaylistMetadata;
    isLoading?: boolean;
    onFieldChange: <K extends keyof WidgetPlaylistProperties>(fieldName: K) => (nextValue: PlaylistFieldOrder) => void;
}

const CLASSNAME = 'playlist-metadata-selection';

/**
 *
 * @param PlaylistMetadataSelectionProps
 * @returns PlaylistMetadataSelection
 */
export const PlaylistMetadataSelection = ({
    className,
    properties,
    isLoading,
    onFieldChange,
}: PlaylistMetadataSelectionProps) => {
    const { translateKey } = useTranslate();
    const { block, element } = useClassnames(CLASSNAME);

    const settings: Setting<PlaylistFieldOrder>[] = [
        {
            label: translateKey(GLOBAL.THUMBNAIL),
            name: 'thumbnail',
        },
        {
            label: translateKey(GLOBAL.TITLE),
            name: 'title',
        },
        {
            label: translateKey(WIDGET_PLAYLIST.NUMBER_OF_VIDEOS),
            name: 'video_count',
        },
        {
            label: translateKey(GLOBAL.DATE),
            name: 'date',
        },
    ];

    return (
        <div className={block([className])}>
            <Heading as="h5" className={element('subtitle')}>
                {translateKey(WIDGET_BASE.SETTINGS_INFORMATION_DISPLAYED_TITLE)}:&nbsp;
                {translateKey(WIDGET_PLAYLIST.PLAYLISTS)}
            </Heading>

            <GenericSwitchList<PlaylistFieldOrder>
                className={element('switch-list')}
                items={settings}
                order={properties.playlistFieldOrder}
                onChange={onFieldChange('playlistFieldOrder')}
                isLoading={isLoading}
            />
        </div>
    );
};
